import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgSort = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path
      fill={_.color}
      fillRule="evenodd"
      d="M.214 5.468 3.49 2.221A.65.65 0 0 1 3.997 2q.298 0 .513.22l3.276 3.247A.67.67 0 0 1 8 5.954q0 .297-.195.485a.67.67 0 0 1-.487.183.63.63 0 0 1-.475-.195l-1.345-1.35-.864-.97.052 1.342v7.882a.64.64 0 0 1-.195.48.67.67 0 0 1-.488.189.7.7 0 0 1-.5-.19.65.65 0 0 1-.189-.479V5.45l.052-1.343-.87.971-1.34 1.35a.65.65 0 0 1-.48.195.67.67 0 0 1-.488-.183A.66.66 0 0 1 0 5.954a.67.67 0 0 1 .214-.486m15.578 5.058-3.278 3.26A.68.68 0 0 1 12 14a.7.7 0 0 1-.507-.214l-3.278-3.26A.66.66 0 0 1 8 10.04q0-.296.189-.48a.7.7 0 0 1 .494-.182q.28 0 .475.19l1.34 1.348.871.978-.052-1.343V3.668q0-.29.195-.479A.67.67 0 0 1 12 3q.3 0 .494.19.195.188.195.478v6.883l-.052 1.343.872-.978 1.34-1.349a.64.64 0 0 1 .475-.19q.299 0 .487.184a.64.64 0 0 1 .189.479q0 .277-.208.486"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgSort);
export default ForwardRef;
